<template>
  <!-- details -->
  <div>
    <content-header title="Entity Details" :sub-title="subTitle" class="mb-0 mt--10"/>
    <h3>Entity Details</h3>
    <el-form ref="form" :model="value" :rules="rules" label-position="top" v-if="isLoaded">
      <el-row :gutter="60">
        <el-col :span="24" :md="8">
          <div>Entity Name</div>
          <el-form-item prop="name" class="mt-10">
            <el-input v-model="value.name" disabled placeholder="E.g: Awesome Entity"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="60">
        <el-col :span="24" :md="8">
          <el-input-title required>Contact Name</el-input-title>
          <el-form-item prop="contact.name" class="mt-10">
            <el-input v-model="value.contact.name" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="8">
          <el-input-title required>Contact Number</el-input-title>
          <el-form-item prop="contact.number" class="mt-10">
            <el-input v-model="value.contact.number" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="8">
          <el-input-title required>Contact Email</el-input-title>
          <el-form-item prop="contact.email" class="mt-10">
            <el-input type="email" v-model="value.contact.email" placeholder=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="60">
        <el-col :span="24" :md="16">
          <el-input-title>ABN</el-input-title>
          <el-form-item prop="meta.abn" class="mt-10">
              <el-autocomplete
                class="mt-05"
                v-model="selectedAbn"
                :fetch-suggestions="searchAbn"
                @select="handleSelect"
                placeholder="Search by name"
              ></el-autocomplete>
          </el-form-item>
        </el-col>
      </el-row>
      <h3>Payment Contact Details</h3>
      <el-row :gutter="60">
        <el-col :span="24" :md="8" >
          <el-input-title required>Email</el-input-title>
          <el-form-item prop="payment.email" class="mt-10">
            <el-input v-model="value.payment.email" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import _ from 'lodash';
import {
  errormsg,
  // genders
} from '@/utils/constants';
import { checkEmail, checkMobile } from '@/utils/form-helpers';

const defaultRequiredRule = { required: true, trigger: 'blur', message: errormsg.required };

export default {
  name: 'EntityDetails',
  props: ['value', 'entityType'], // entity object state /association
  data() {
    return {
      isLoaded: true,
      subTitle: 'Enter your entity contact information.',
      registration: {},
      abnOptions: [],
      rules: {
        'contact.name': defaultRequiredRule,
        'contact.number': { validator: checkMobile, trigger: 'blur' },
        'contact.email': [{ validator: checkEmail, trigger: 'blur' }],
      },
      selectedAbn: ''
    };
  },
  mounted() {
    this.$set(this, 'selectedAbn', this.value.meta.abn);
  },
  methods: {
    handleSelect(selected) {
      this.value.meta.abn = selected.abn;
    },
    updateStep() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.$store.commit('loading', { loading: true, text: 'Loading...' });
        this.$http.put(`/assemble/api/v1/portal/entity-registrations/entities/${this.value._id}`, {
          entityType: this.entityType,
          contact: this.value.contact,
          meta: this.value.meta,
        }).then(() => {
          this.$emit('update-step', { entity: this.value });
          this.$store.commit('loading', false);
        }).catch((e) => {
          this.$message.error(e.response.data.message);
          this.$store.commit('loading', false);
        });
      });
    },
    // eslint-disable-next-line func-names
    searchAbn: _.debounce(function (query, cb) {
      if (query && query.length < 3) {
        cb([]);
      }
      this.$http.post('/assemble/api/v1/portal/abr/search', { query }).then((res) => {
        cb(res.data.data.map((a) => ({ value: `${a.text} (${a.abn})`, abn: a.abn })));
      }).catch(() => {});
    }, 500),
  },
  filters: {
  }
};
</script>

<style scoped lang="scss">
.manualAddressBtn {
  &:hover {
    color: $highlight !important;
  }
}
.el-select {
  width: 100%;
}
</style>
